export const calculateAge = (date?: Date | string | null) => {
    if (!date) return { years: 0, months: 0 };
    date = new Date(date);
    const today = new Date();
    let years = today.getFullYear() - date.getFullYear();
    let months = today.getMonth() - date.getMonth();

    if (months < 0) {
        years--;
        months += 12;
    }

    return { years, months };
};